import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "store/hooks";
import { Timeline } from "../../../components/timeline/Timeline";
import { setTimelineInitValues } from "../../../store/timeline";
import { isClientFormUser } from "../clientVehicleSpec";
import { hasVehicleBeenActivated } from "../helpers";
import FinanceForm from "./FinanceForm/FinanceForm";
import FinancePreview from "./FinancePreview";
import RequestedOfferSummary from "./RequestedOfferSummary";

// Target of the sidebar's "Financials" entry and of the ?tab= deep links built
// from the insurance-line icons in the vehicle list. It sits on the premium
// lines rather than on the whole section, because the finance fields now render
// above them and those links are about the lines.
const FINANCE_SECTION_ID = "finance-vehicle-form";

const FinanceSection = ({
  vehicle,
  route,
  defaultSettings,
  initialValues,
  formikProps,
}) => {
  const isReadOnlyMode = route === "readOnlyVehicle";

  const dispatch = useDispatch();
  const fleetCountryCode = useSelector((s) => s.vehicle.fleet.countryCode);
  const vehicleAppSettings = useSelector((s) => s.vehicle.vehicleAppSettings);
  const userRole = useSelector((s) => s.auth.userRole);
  // The premium/timeline "financial section" is hidden from the AT / CZ client
  // (external) while the vehicle is still being entered: a client-created
  // vehicle stays pending until an internal user reviews the client's entries
  // and enters premiums. Once the vehicle has been activated the client sees it
  // too, and clients in the other countries always do.
  const isClientForm = isClientFormUser(
    vehicleAppSettings?.COUNTRY_CODE,
    userRole
  );
  const showTimeline =
    !isClientForm || !!hasVehicleBeenActivated({ vehicle, route });

  const showPremiumLines =
    !!vehicle &&
    showTimeline &&
    route !== "duplicateVehicle" &&
    route !== "editTempVehicle";

  useEffect(() => {
    if (route !== "editTempVehicle")
      dispatch(
        setTimelineInitValues({
          types: vehicleAppSettings?.VEHICLE_TIMELINE_TYPES,
          readOnly: isReadOnlyMode,
          countryCode: fleetCountryCode,
        })
      );
  }, [route, fleetCountryCode, vehicleAppSettings]);

  return (
    <div>
      {isReadOnlyMode ? (
        <>
          <FinancePreview vehicle={vehicle} route={route} />
          {vehicle && showTimeline && (
            <div
              style={{
                padding: 50,
              }}
            >
              {route !== "editTempVehicle" && <Timeline width={1100} />}
            </div>
          )}
        </>
      ) : (
        <>
          {/* Section order mirrors the read-only preview: vehicle values /
              VAT / leasing fields first, then the premium lines (timeline).
              Without premium lines these fields are all the section has, so
              they take over the anchor and the nav entry still leads here. */}
          <div id={showPremiumLines ? undefined : FINANCE_SECTION_ID}>
            <FinanceForm
              formikProps={formikProps}
              vehicle={vehicle}
              route={route}
            />
          </div>

          {showPremiumLines && (
            <div id={FINANCE_SECTION_ID}>
              {/* What the client requested — shown to the internal reviewer
                  right before the timeline so they can enter the matching
                  premiums and additional coverages while confirming. */}
              <RequestedOfferSummary vehicle={vehicle} />
              <Timeline width={970} marginLeft={70} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FinanceSection;
